import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modelSelect", "specificModelField"];

  connect() {
    this.integratedControls = JSON.parse(this.element.dataset.integratedControls);
  }

  updateModels(event) {
    const manufacturer = event.target.value;
    this.modelSelectTarget.innerHTML = "";

    if (manufacturer && this.integratedControls[manufacturer]) {
      this.modelSelectTarget.disabled = false;

      const blankOption = document.createElement("option");
      blankOption.value = "";
      blankOption.textContent = "Select a model";
      this.modelSelectTarget.appendChild(blankOption);

      this.integratedControls[manufacturer].forEach((model) => {
        const option = document.createElement("option");
        option.value = model;
        option.textContent = model;
        this.modelSelectTarget.appendChild(option);
      });
    } else {
      this.modelSelectTarget.disabled = true;
    }

    // Hide specific model field when manufacturer changes
    if (this.hasSpecificModelFieldTarget) {
      this.specificModelFieldTarget.classList.add("hidden");
    }
  }

  updateSpecificModelVisibility(event) {
    if (!this.hasSpecificModelFieldTarget) return;

    const selectedModel = event.target.value;

    this.#specificModelFieldInput.value = "";

    const hasWildcard =
      selectedModel && (selectedModel.includes("[") || selectedModel.includes("*"));

    if (hasWildcard) {
      this.specificModelFieldTarget.classList.remove("hidden");
      this.updatePlaceholder(selectedModel);
    } else {
      this.specificModelFieldTarget.classList.add("hidden");
    }
  }

  updatePlaceholder(wildcardModel) {
    if (!this.hasSpecificModelFieldTarget) return;

    const input = this.#specificModelFieldInput;

    // Generate helpful example: [XXX] -> ABC, * -> 123
    const example = wildcardModel
      .replace(/\[X+\]/g, (match) => {
        const count = match.length - 2;
        return "ABC".substring(0, count);
      })
      .replace(/\*/g, "123");

    input.placeholder = `e.g., ${example}`;
  }

  get #specificModelFieldInput() {
    return this.specificModelFieldTarget.querySelector("input");
  }
}
